export default __webpack_public_path__ + "static/media/umum4.c41d794d.png";